<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar" />
      <section class="qi-content">
        <header>
          <h1>Confirmação de Valores</h1>
        </header>

        <vs-row>
          <NewSale />
        </vs-row>

        <vs-card
          v-for="(item, index) in financial.itens"
          :key="index"
          v-show="item.visible"
        >
          <p v-if="index == 0">
            {{ financial.introduction }}
          </p>
          <div slot="header">
            <h3>
              {{ item.name }}
            </h3>
          </div>

          <p v-html="item.message"></p>
          <div
            v-if="
              critical && // S - Possui Bolsa de Turma de Crítica
              item.field == 'confere-finan'
            "
          >
            <p style="font-weight: bold">
              * Informar uso da Bolsa de Turma de Crítica *
            </p>
          </div>

          <div v-if="item.name == 'Parcelamento'">
            <vs-row>
              <vs-button
                v-if="hasPermissionToAddScholarship != -1"
                icon="attach_money"
                style="margin: 10px"
                color="#139B0E"
                @click="openPopup()"
              >
                Adicionar Bolsa
              </vs-button>
            </vs-row>
            <vs-row>
              <vs-divider />
              <vs-table class="pd-table" :data="parcelas">
                <template slot="thead">
                  <th>Parcela</th>
                  <th>Valor</th>
                  <th>Bolsa</th>
                  <th>(-) Bolsa</th>
                  <th>Valor com Bolsa</th>
                  <th>(-) Adimplência</th>
                  <th>Líquido (até o vcto) <br /></th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td> {{ indextr + 1 }} </vs-td>
                    <vs-td> R$ {{ pre.VALORPARCELA }} </vs-td>
                    <vs-td> {{ data[indextr].totalbolsa }}% </vs-td>
                    <vs-td> R$ {{ data[indextr].descontoBolsa }} </vs-td>
                    <vs-td> R$ {{ data[indextr].valorComBolsa }} </vs-td>
                    <vs-td> R$ {{ data[indextr].descontoAdimp }} </vs-td>
                    <vs-td> R$ {{ data[indextr].liquido }} </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vs-row>
          </div>
          <div>
            <p
              v-if="
                (pre.FORMA_PAGTO_PARCELA == 'CRÉDITO RECORRENTE' ||
                  pre.FORMA_PAGTO_PARCELA == 'RECORRENTE') &&
                pre.CARTAOCADASTRADO == 'N' &&
                item.field == 'pag-parc'
              "
            >
              <strong>
                ATENÇÃO! <br />
                Cartão não cadastrado!
              </strong>
            </p>
            <vs-row style="margin-top: 10px">
              <vs-col vs-lg="6" vs-sm="12">
                <vs-button
                  v-if="
                    (pre.FORMA_PAGTO_PARCELA == 'CRÉDITO RECORRENTE' ||
                      pre.FORMA_PAGTO_PARCELA == 'RECORRENTE') &&
                    item.field == 'pag-parc'
                  "
                  icon="email"
                  style="width: 100%"
                  color="danger"
                  @click="sendMail()"
                >
                  Reenviar E-mail para Cadastro Recorrente
                </vs-button>
              </vs-col>
              <vs-col
                :vs-lg="
                  pre.FORMA_PAGTO_PARCELA == 'CRÉDITO RECORRENTE' ||
                  pre.FORMA_PAGTO_PARCELA == 'RECORRENTE'
                    ? '6'
                    : '12'
                "
                vs-sm="12"
              >
                <vs-button
                  v-if="item.field == 'pag-parc'"
                  icon="shopping_cart"
                  style="width: 100%"
                  color="danger"
                  @click="changePay()"
                >
                  Trocar Forma de Pagamento
                </vs-button>
              </vs-col>
              <vs-col vs-w="12">
                <vs-button
                  v-if="item.field == 'venc-parc'"
                  icon="event"
                  style="width: 100%"
                  color="danger"
                  @click="changeDueDate()"
                >
                  Trocar Data de Vencimento
                </vs-button>
              </vs-col>
              <vs-divider />
              <vs-col vs-lg="6" vs-sm="12">
                <vs-button
                  icon="arrow_back"
                  style="width: 100%"
                  @click="back(item, index)"
                  v-if="item.field !== 'valor_taxa'"
                >
                  Voltar
                </vs-button>
              </vs-col>
              <vs-col vs-lg="6" vs-sm="12">
                <vs-button
                  icon="check_circle"
                  style="width: 100%"
                  color="#139B0E"
                  @click="confirmAdvance(item, index)"
                >
                  Confirmar e Avançar
                </vs-button>
              </vs-col>
            </vs-row>
          </div>
        </vs-card>
        <vs-card style="height: 270px">
          <h2>Divergência</h2>
          <Divergence />
        </vs-card>
        <vs-card style="height: 140px">
          <h2>Cancelamento</h2>
          <!--Componente Cancelamento de Pré-->
          <ReasonsCancel />
        </vs-card>
        <vs-popup title="Forma de Pagamento" :active.sync="sendPayment">
          <vs-row>
            <vs-card>
              <vs-col>
                <div>
                  <vs-select
                    width="100%"
                    v-model="formPayment"
                    placeholder="Selecione uma Forma de Pagamento"
                  >
                    <vs-select-item
                      :key="index"
                      :value="option"
                      :text="option.DESCRICAO"
                      v-for="(option, index) in removeDuplicates(
                        paymentForm,
                        this.pre.FORMA_PAGTO_PARCELA
                      )"
                    />
                  </vs-select>
                  <vs-button
                    icon="check_circle"
                    :disabled="
                      !formPayment ||
                      formPayment.DESCRICAO == this.pre.FORMA_PAGTO_PARCELA
                    "
                    style="width: 100%; margin-top: 10px"
                    color="#139B0E"
                    @click="paymentChange(formPayment)"
                  >
                    Alterar
                  </vs-button>
                </div>
              </vs-col>
            </vs-card>
          </vs-row>
        </vs-popup>
        <vs-popup title="Dia do Vencimento" :active.sync="sendDueDate">
          <vs-row>
            <vs-card>
              <vs-col>
                <div>
                  <legend>Selecione o Dia do Vencimento</legend>
                  <fieldset style="border-radius: 8.5px; padding: 8.5px">
                    <div style="display: flex; justify-content: space-between">
                      <vs-radio v-model="dueDate" vs-value="1">1</vs-radio>
                      <vs-radio v-model="dueDate" vs-value="2">2</vs-radio>
                      <vs-radio v-model="dueDate" vs-value="3">3</vs-radio>
                      <vs-radio v-model="dueDate" vs-value="4">4</vs-radio>
                      <vs-radio v-model="dueDate" vs-value="5">5</vs-radio>
                      <vs-radio v-model="dueDate" vs-value="6">6</vs-radio>
                      <vs-radio v-model="dueDate" vs-value="7">7</vs-radio>
                      <vs-radio v-model="dueDate" vs-value="8">8</vs-radio>
                      <vs-radio v-model="dueDate" vs-value="9">9</vs-radio>
                      <vs-radio v-model="dueDate" vs-value="10">10</vs-radio>
                    </div>
                    <vs-divider />
                    <div style="display: flex; justify-content: space-between">
                      <vs-radio v-model="dueDate" vs-value="11">11</vs-radio>
                      <vs-radio v-model="dueDate" vs-value="12">12</vs-radio>
                      <vs-radio v-model="dueDate" vs-value="13">13</vs-radio>
                      <vs-radio v-model="dueDate" vs-value="14">14</vs-radio>
                      <vs-radio v-model="dueDate" vs-value="15">15</vs-radio>
                      <vs-radio v-model="dueDate" vs-value="16">16</vs-radio>
                      <vs-radio v-model="dueDate" vs-value="17">17</vs-radio>
                      <vs-radio v-model="dueDate" vs-value="18">18</vs-radio>
                      <vs-radio v-model="dueDate" vs-value="19">19</vs-radio>
                      <vs-radio v-model="dueDate" vs-value="20">20</vs-radio>
                    </div>
                    <vs-divider />
                    <div style="display: flex; justify-content: space-between">
                      <vs-radio v-model="dueDate" vs-value="21">21</vs-radio>
                      <vs-radio v-model="dueDate" vs-value="22">22</vs-radio>
                      <vs-radio v-model="dueDate" vs-value="23">23</vs-radio>
                      <vs-radio v-model="dueDate" vs-value="24">24</vs-radio>
                      <vs-radio v-model="dueDate" vs-value="25">25</vs-radio>
                      <vs-radio v-model="dueDate" vs-value="26">26</vs-radio>
                      <vs-radio v-model="dueDate" vs-value="27">27</vs-radio>
                      <vs-radio v-model="dueDate" vs-value="28">28</vs-radio>
                      <vs-radio v-model="dueDate" vs-value="29">29</vs-radio>
                      <vs-radio v-model="dueDate" vs-value="30">30</vs-radio>
                    </div>
                    <vs-divider />
                    <div style="display: flex; justify-content: space-between">
                      <vs-radio v-model="dueDate" vs-value="31">31</vs-radio>
                    </div>
                  </fieldset>
                  <vs-button
                    icon="check_circle"
                    :disabled="!dueDate"
                    style="width: 100%; margin-top: 10px"
                    color="#139B0E"
                    @click="dateChange(dueDate)"
                  >
                    Alterar
                  </vs-button>
                </div>
              </vs-col>
            </vs-card>
          </vs-row>
        </vs-popup>
        <vs-popup
          title="Adicionar Bolsa"
          :active.sync="showAddScholarshipScreen"
          ><vs-row>
            <vs-col>
              <p>
                <vs-select
                  width="100%"
                  placeholder="Selecione uma bolsa"
                  autocomplete
                  v-model="scholarshipSelected"
                  v-on:input="selectScholarship()"
                >
                  <vs-select-item
                    v-for="(option, i) in scholarshipOptions"
                    :key="i"
                    :value="option"
                    :text="option.BOLSA"
                  />
                </vs-select>
              </p>
              <p v-if="scholarshipSelected">
                * Desconto: {{ scholarshipSelected.VALOR }}
              </p>

              <p v-if="scholarshipSelected">
                Parcela inicial
                <vs-input v-model="inicialInstallment" name="parcelainicial"
                  >1</vs-input
                >
              </p>
              <p v-if="scholarshipSelected">
                Parcela Final
                <vs-input
                  v-model="finalInstallment"
                  :text="pre.NUMPARCELA"
                ></vs-input>
              </p>
              <div v-if="scholarshipSelected">
                <p v-if="scholarshipSelected.PERMITEALTERARVALOR == 'S'">
                  Editar Percentual de Desconto
                  <vs-input v-model="percent"></vs-input>
                </p>
              </div>
              <p v-if="scholarshipSelected">
                <vs-button class="qi-bt" @click="addScholarship()"
                  >Adicionar Bolsa</vs-button
                >
              </p>
              <vs-alert
                title="Erro no processo"
                color="danger"
                v-if="errorScholarship"
              >
                {{ errorScholarship }}
              </vs-alert>
            </vs-col>
          </vs-row>
        </vs-popup>
      </section>
    </div>
  </div>
</template>
<script>
import AuditModel from "../model/Audit.js";
import PreRegistrationService from "../services/preRegistration.js";
import { getStepsInformation } from "../helpers/storage";
import { formatDateToLocale, getLoginDataFromStorage } from "../helpers";
import Payment from "../services/payment";
import Financial from "../services/financial";
import { notifyError, notifySuccess } from "../helpers/index.js";
import { getProfiles } from "../helpers/storage";
import { onlyUpdateDiscussion } from "../helpers/service";
import Divergence from "../components/Divergence.vue";
import ReasonsCancel from "../components/ReasonsCancel.vue";

export default {
  name: "AuditStep3",
  components: {
    Divergence,
    ReasonsCancel,
  },
  data: () => ({
    userData: "",
    financial: null,
    coligateId: null,
    preRegistrationId: null,
    error: null,
    sendPayment: false,
    sendDueDate: false,
    errorScholarship: null,
    pre: {
      FORMA_PAGTO_PARCELA: "",
      TOKENCARTAO: "",
    },
    errorCancel: null,
    newPayment: null,
    paymentForm: [],
    formPayment: null,
    dueDate: null,
    formDueDate: null,
    scholarshipOptions: [],
    scholarships: null,
    scholarshipsCritical: null,
    critical: false,
    parcelas: [],
    showAddScholarshipScreen: false,
    scholarshipSelected: null,
    inicialInstallment: "1",
    finalInstallment: "1",
    percent: 0,
    hasPermissionToAddScholarship: -1,
  }),
  created() {
    this.userData = getLoginDataFromStorage();
    //montagem do objeto de confirmações financeiras
    this.financial = new AuditModel().getItem("financial");
    //puxar a pré que está salva na sessão e busca os dados da pré no endpoint
    const stepsData = getStepsInformation();
    const preRegistrationId = stepsData.preRegistrationId;
    this.loadPre(preRegistrationId);
    const profiles = getProfiles();
    this.hasPermissionToAddScholarship = profiles.indexOf("EditaBolsaPre");
  },
  methods: {
    removeDuplicates(items, campo) {
      let noDuplicates = [];
      for (let i = 0; i < items.length; i++) {
        let duplicate = false;
        for (let j = 0; j < noDuplicates.length; j++) {
          if (items[i].DESCRICAO == campo) {
            duplicate = true;
          }
        }

        if (!duplicate) {
          noDuplicates.push(items[i]);
        }
      }

      noDuplicates.sort((a, b) => a.DESCRICAO.localeCompare(b.DESCRICAO));

      return noDuplicates;
    },
    selectScholarship() {
      this.percent = this.scholarshipSelected.VALOR;
    },
    addScholarship() {
      //code here
      if (
        parseInt(this.inicialInstallment) < 1 ||
        parseInt(this.inicialInstallment) > parseInt(this.pre.NUMPARCELA) ||
        parseInt(this.inicialInstallment) > parseInt(this.finalInstallment) ||
        parseInt(this.finalInstallment) > parseInt(this.pre.NUMPARCELA) ||
        parseInt(this.finalInstallment) < 1 ||
        parseFloat(this.percent) == 0 ||
        parseFloat(this.percent) < 0 ||
        parseFloat(this.percent) > parseFloat(this.scholarshipSelected.VALOR)
      ) {
        notifyError(this, "Revise as informações de bolsa!");
        return;
      }

      this.errorScholarship = null;
      const payload = {
        colligateCod: this.scholarshipSelected.CODCOLIGADA,
        preRegistrationId: this.pre.IDPREMATRICULA,
        scholarshipCod: this.scholarshipSelected.CODBOLSA,
        inicialInstallment: this.inicialInstallment,
        finalInstallment: this.finalInstallment,
        percent: this.percent,
        branchCod: this.pre.CODFILIAL,
      };
      this.$vs.loading();
      new PreRegistrationService()
        .addScholarship(payload)
        .then(() => {
          notifySuccess(this, "Bolsa adicionada com sucesso!");
          this.scholarshipSelected = null;
          this.showAddScholarshipScreen = false;
          this.loadPre(this.pre.IDPREMATRICULA);
        })
        .catch((error) => {
          this.errorScholarship = error.response.data.error;
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    paymentChange(formPayment) {
      const payload = {
        colligateId: formPayment.CODCOLIGADA,
        preRegistrationId: this.pre.IDPREMATRICULA,
        idDescAdimPgto: formPayment.IDDESCADIMPGTO,
        codUsuario: this.userData.username,
      };
      this.sendPayment = false;
      this.$vs.loading();
      new Financial()
        .changePayment(payload)
        .then((res) => {
          this.newPayment = res.data;
          notifySuccess(this, "Forma de pagamento alterada com sucesso!");

          onlyUpdateDiscussion(
            "Alterou a forma de pagamento do cliente \n" +
              "DE: " +
              this.pre.FORMA_PAGTO_PARCELA +
              "\n" +
              "PARA: " +
              this.formPayment.DESCRICAO,
            this.pre.CODCOLIGADA,
            this.pre.CODLOCAL,
            this.pre.CODATENDIMENTO
          );

          setTimeout(function () {
            location.reload(true);
          }, 500);
        })
        .catch((error) => {
          notifyError(this, "Erro ao alterar a forma de pagamento: " + error);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    dateChange(dueDate) {
      const payload = {
        colligateId: this.pre.CODCOLIGADA,
        preRegistrationId: this.pre.IDPREMATRICULA,
        dueDate: dueDate,
        codUsuario: this.userData.username,
      };
      this.sendDueDate = false;
      this.$vs.loading();
      new Financial()
        .changeDueDate(payload)
        .then((res) => {
          this.newPayment = res.data;
          notifySuccess(this, "Dia do vencimento alterado com sucesso!");

          onlyUpdateDiscussion(
            "Alterou o dia do vencimento das parcelas do cliente para: " +
              dueDate,
            this.pre.CODCOLIGADA,
            this.pre.CODLOCAL,
            this.pre.CODATENDIMENTO
          );

          setTimeout(function () {
            location.reload(true);
          }, 500);
        })
        .catch((error) => {
          notifyError(this, "Erro ao alterar o dia do vencimento: " + error);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    openPopup() {
      this.showAddScholarshipScreen = true;
      this.loadScholarships();
      this.finalInstallment = this.pre.NUMPARCELA;
    },

    changePay() {
      this.sendPayment = true;
      this.formPayment = null;
    },

    changeDueDate() {
      this.sendDueDate = true;
      this.dueDate = null;
    },

    loadPre(preRegistrationId) {
      this.critical = false;
      this.$vs.loading();
      new PreRegistrationService()
        .getPreRegistration(1, preRegistrationId)
        .then((res) => {
          this.pre = res.data;
          this.$vs.loading.close();
          this.financial = JSON.stringify(this.financial);
          new Financial()
            .searchPayment(
              this.pre.CODCOLIGADA,
              this.pre.AVISTA,
              this.pre.IDCLASSIFICACAO
            )
            .then((res) => {
              this.paymentForm = res.data;
            })
            .catch((error) => {
              this.error = error;
            });
          new PreRegistrationService()
            .getScholarships(1, preRegistrationId)
            .then((res) => {
              this.scholarships = Array.isArray(res.data) ? res.data : [res.data];
              this.scholarshipsCritical = this.scholarships.filter(
                (bolsa) => bolsa.BOLSACRITICA === "S"
              );
              if (this.scholarshipsCritical.length > 0) {
                this.critical = true;
              }
              console.log(this.scholarshipsCritical);
              this.$vs.loading.close();
              !Array.isArray(this.scholarships)
                ? (this.scholarships = [this.scholarships])
                : "";
              if (this.scholarships) {
                //gerar simulação
                this.parcelas = [];
                let calculado = {};
                const VALORPARCELA = parseFloat(this.pre.VALORPARCELA);
                for (
                  let parcela = 1;
                  parcela <= parseInt(this.pre.NUMPARCELA);
                  parcela++
                ) {
                  let totalbolsa = 0;
                  this.scholarships.forEach((bolsa) => {
                    if (
                      bolsa.PARCELAINICIAL <= parcela &&
                      bolsa.PARCELAFINAL >= parcela
                    )
                      totalbolsa = totalbolsa + parseFloat(bolsa.PERCDESCONTO);
                  });

                  let descontoBolsa = (
                    (VALORPARCELA * totalbolsa) /
                    100
                  ).toFixed(2);
                  let valorComBolsa = (VALORPARCELA - descontoBolsa).toFixed(2);
                  let descontoAdimp = (
                    (valorComBolsa * parseFloat(this.pre.DESCADIM)) /
                    100
                  ).toFixed(2);
                  let liquido = (valorComBolsa - descontoAdimp).toFixed(2);

                  calculado = {
                    totalbolsa,
                    descontoBolsa,
                    valorComBolsa,
                    descontoAdimp,
                    liquido,
                  };
                  this.parcelas.push(calculado);
                }

                this.financial = this.financial.replace(
                  "@VALORTAXA",
                  (
                    (Number(this.pre.VALORTAXA) *
                      (100 - Number(this.pre.DESCONTOTAXA))) /
                    100
                  ).toFixed(2)
                ); // CÁLCULO VALOR DA TAXA COM DESCONTO
                this.financial = this.financial.replace(
                  "@FORMAPAGTOTAXA",
                  this.pre.FORMA_PAGTO_TAXA
                );
                this.financial = this.financial.replace(
                  "@VENCIMENTOTAXA",
                  formatDateToLocale(this.pre.DTVENCIMENTOTAXA)
                );
                this.financial = this.financial.replace(
                  "@FORMAPAGTOPARCELA",
                  this.pre.FORMA_PAGTO_PARCELA
                );
                this.financial = this.financial.replaceAll(
                  "@VALORPARCELA",
                  this.pre.VALORPARCELA
                ); // AJUSTAR PRA TRAZER VALOR LIQUIDO?
                this.financial = this.financial.replaceAll(
                  "@DESCADIMP",
                  this.pre.DESCADIM
                );

                this.financial = this.financial.replace(
                  "@NUMPARCELA",
                  this.pre.NUMPARCELA
                );
                this.financial = this.financial.replace(
                  "@DTVENCIMENTOPARC",
                  formatDateToLocale(this.pre.DTVENCIMENTOPARC)
                );
                this.financial = this.financial.replace(
                  "@DTVENCIMENTOPARC2",
                  formatDateToLocale(this.pre.DTVENCIMENTOPARC2)
                );
                this.financial = this.financial.replace(
                  "@DESCADIM",
                  this.pre.DESCADIM
                );
                this.financial = this.financial.replace(
                  "@PRIMEIRONOME",
                  this.pre.CLIENTE_NOME
                );
                this.financial = JSON.parse(this.financial);
              }
            })
            .catch((error) => {
              this.error = error;
            });
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    sendMail() {
      this.$vs.loading();
      const payload = {
        coligateId: this.pre.CODCOLIGADA,
        preRegistrationId: this.pre.IDPREMATRICULA,
      };

      new Payment()
        .getCardRegistration(payload)
        .then(({ data }) => {
          this.card = data;
          this.$vs.loading.close();
          notifySuccess(this, "Link enviado com sucesso!");
        })
        .catch(() => {
          this.$vs.loading.close();
          notifyError(this, "Erro ao enviar!");
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    loadScholarships() {
      //load
      this.$vs.loading();
      new Financial()
        .getExtraScholarship(this.pre.CODCOLIGADA, this.pre.IDPERLET)
        .then((res) => {
          //code here
          this.scholarshipOptions = res.data;
        })
        .catch(() => {
          //code here
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    confirmAdvance(item, index) {
      item.visible = false;
      item.valid = true;
      if (index == this.financial.itens.length - 1) {
        this.$router.push("/audits/4");
      } else {
        this.financial.itens[index + 1].visible = true;
      }
    },
    back(item, index) {
      item.visible = false;
      item.valid = true;
      this.financial.itens[index - 1].visible = true;
    },
    goTo(route) {
      this.$router.push(route);
    },
  },
};
</script>
<style>
.introduction {
  padding: 1% 0% 1% 1%;
  font-family: "Segoe UI", Tahoma, Verdana, sans-serif;
  font-weight: 400;
  font-size: 20px;
  color: #414141;
  text-align: justify;
}
.name {
  margin: 1% 2% 0% 1%;
}
</style>
